import { useFormatting } from "@msys/ui";
import type { GridColDef } from "@mui/x-data-grid-premium";
import React from "react";
import type { EstimatedCalculation__ItemFragment } from "../../doc-items/boxes/EstimatedCalculationBox.generated.js";
import type { DocDataGrid_ItemFragment } from "../DocDataGrid.generated.js";
import type { DocDataGridRow } from "../types.js";

function PriceCell({ value }: { value: number }) {
  const { getFormattedPrice } = useFormatting();
  return <span>{getFormattedPrice(value)}</span>;
}

interface Options {
  headerName: string;
}

export function createMaterialPricePerUnitColumn<
  T extends DocDataGrid_ItemFragment & EstimatedCalculation__ItemFragment,
>(options: Options): GridColDef<DocDataGridRow<T>> {
  return {
    field: "materialPricePerUnit",
    headerName: options.headerName,
    width: 100,
    editable: false,
    sortable: false,
    filterable: false,
    valueGetter: (_value, row) =>
      row.item?.proposedCalculation?.materialPricePerUnit ?? 0,
    renderCell: params => {
      if (params.row.kind === "input" || !params.row.item) return null;
      if (params.row.item.type !== "paid") return null;
      return <PriceCell value={params.value ?? 0} />;
    },
  };
}
